<template>
  <div class="search" :class="{ opacity0: professionMore == 0 }">
    <ul class="ml20 part03">
      <li class="flex nowrap start mb10" ref="profession">
        <dt class="nowrap title">题库分类：</dt>
        <dd class="flex flex1" :class="{
          mr50: professionMore > 1,
          'height34px ohide': professionMore == 2,
        }">
          <a :class="{ on: ClassifyID == 0 }" @click="ClassifyID = 0">全部</a>
          <a @click="ClassifyID = item.ClassifyID" :class="{ on: ClassifyID == item.ClassifyID }"
            v-for="(item, index) in classifyList" :key="index">{{ item.ClassifyName }}</a>
        </dd>
        <dd v-if="professionMore > 1" class="absolute r t mt27 Conhover C888 pointer">
          <p v-if="professionMore == 2" @click="professionMore = 3">
            展开 <i class="el-icon-arrow-down"></i>
          </p>
          <p v-if="professionMore == 3" @click="professionMore = 2">
            收起 <i class="el-icon-arrow-up"></i>
          </p>
        </dd>
      </li>
    </ul>
    <div class="navbar flex">
      <div v-for="(item, index) in OrderByList" :key="index"
        :class="OrderBy == item.value ? 'navbar-item actives' : 'navbar-item'" @click="OrderBy = item.value">
        <img :src="OrderBy == item.value ? item.img1 : item.img" alt="" :class="item.class" />
        <span>{{ item.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Exercise_GetClassifys } from "@/api/qbank";
export default {
  name: "qbankTypeList",
  data() {
    return {
      classifyList: [],
      ClassifyID: 0,
      professionMore: 0, // 0隐藏  1单行显示 2多行收起 3多行展开
      OrderBy: 3,
      OrderByList: [
        {
          name: "推荐",
          value: 3,
          img: require("@/assets/img/home/48.png"),
          img1: require("@/assets/img/home/49.png"),
          class: "recommend",
        },
        {
          name: "最新",
          value: 1,
          img: require("@/assets/img/home/50.png"),
          img1: require("@/assets/img/home/51.png"),
          class: "new",
        },
        {
          name: "最热",
          value: 2,
          img: require("@/assets/img/home/52.png"),
          img1: require("@/assets/img/home/53.png"),
          class: "hot",
        },
      ],
    };
  },
  watch: {
    OrderBy(v) {
      this.$router.replace({
        query: { ...this.$route.query, OrderBy: v },
      });
    },
    ClassifyID(v) {
      this.$router.replace({
        query: { ...this.$route.query, ClassifyID: v },
      });
    },
  },
  methods: {},
  async created() {
    let { ClassifyID, OrderBy } = this.$route.query;
    if (ClassifyID) {
      ClassifyID = Number(ClassifyID);
      this.ClassifyID = ClassifyID;
    }
    if (OrderBy) {
      OrderBy = Number(OrderBy);
      this.OrderBy = OrderBy;
    }
    Exercise_GetClassifys().then((res) => {
      this.classifyList = res.data;
    });
    this.$nextTick(() => {
      this.professionMore = this.$refs.profession.offsetHeight > 80 ? 2 : 1;
    }, 50);
  },
};
</script>

<style lang="scss" scoped>
.search {
  margin-top: 30px;
  width: 1760px;
  padding: 0 10px;

  background: #ffffff;
  border-radius: 10px;
  font-size: 16PX;
  color: #333333;

  .title {
    padding: 5px 0;
    color: #666666;
    margin-right: 10px;
  }

  .navbar {
    gap: 50px;
    padding: 20px 0;
    margin-left: 15px;
    border-top: 1px solid #e6e6e6;

    .actives {
      color: #1d79ff;
    }

    .navbar-item {
      cursor: pointer;

      img {
        margin-right: 5px;
      }

      .recommend {
        width: 16px;
        height: 15px;
        margin-top: -2px;
      }

      .new {
        width: 25pxx;
        height: 14px;
      }

      .hot {
        width: 22px;
        height: 17px;
      }
    }
  }
}
</style>
